// Generated by CoffeeScript 2.7.0
var MessageSettingsMixins;

import {
  TabItem,
  Tabs
} from 'trunks/vue/admin/components/libs/tabs.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import AfterSubmitSetting from 'trunks/vue/admin/compositions/message_settings/after_submit.js';

import CommentSetting from 'trunks/vue/admin/compositions/message_settings/comment.js';

import PushSetting from 'trunks/vue/admin/compositions/message_settings/push.js';

import RedPacketSetting from 'trunks/vue/admin/compositions/message_settings/red_packet.js';

import ResponseSetting from 'trunks/vue/admin/compositions/message_settings/response.js';

import TagNamecardSetting from 'trunks/vue/admin/compositions/message_settings/tag_namecard.js';

import ReleaseSetting from 'trunks/vue/admin/compositions/message_settings/release_name.js';

import TableMapperSetting from 'trunks/vue/admin/compositions/message_settings/table_mapping.js';

MessageSettingsMixins = {
  components: {
    modal: Modal,
    tabs: Tabs,
    tab: TabItem,
    'push-setting': PushSetting,
    'tags-namecard': TagNamecardSetting,
    'comment': CommentSetting
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      pushSetting: {},
      tagsNamecardSetting: {},
      commentSetting: {},
      enableTabs: false
    };
  },
  created: function() {
    this._separateParams();
    this._setCommentSetting;
    if (this.message.id) {
      return this._removeCacheIfExist();
    } else {
      return this._restoreCacheIfExist();
    }
  },
  methods: {
    ensureClicked: function(modalVm) {
      var data;
      data = this.getData();
      if (data.releaseSetting) {
        this.$emit('ensureClicked', data);
        modalVm.close();
        return this._removeCacheIfExist();
      } else {
        return modalVm.open();
      }
    },
    showMoreTabs: function() {
      return this.enableTabs = true;
    },
    _separateParams: function() {
      this._setPushSetting();
      return this._setTagsNamecardSetting();
    },
    _setPushSetting: function() {
      return this.pushSetting = _.pick(this.message, 'user_boundary', 'push_agent_on_publish_attributes');
    },
    _setTagsNamecardSetting: function() {
      return this.tagsNamecardSetting = _.pick(this.message, 'tag_ids');
    },
    _setCommentSetting: function() {
      return this.commentSetting = _.pick(this.message, 'comment_status');
    },
    _cacheSettings: function() {
      return localStorage.setItem('message_settings', JSON.stringify(this.getData()));
    },
    _restoreCacheIfExist: function() {
      var cache;
      cache = localStorage.getItem('message_settings');
      if (!cache) {
        return;
      }
      return _.extend(this, JSON.parse(cache));
    },
    _removeCacheIfExist: function() {
      return localStorage.removeItem('message_settings');
    }
  }
};

export var MessageSettingsModal = Vue.extend({
  mixins: [MessageSettingsMixins],
  components: {
    'release-setting': ReleaseSetting
  },
  data: function() {
    return {
      releaseSetting: {},
      userBoundary: null
    };
  },
  template: `<modal title='发布确认' extendClass='message-modal' @ensureClicked='ensureClicked' @cancelClicked='_cacheSettings'>
  <tabs customClass='setting-tabs message-settings'
        :hiddenNavs='!enableTabs'
        navsClass='nav reverse'>
    <tab name='接收推送' tabKey='push'>
      <push-setting :initailUserBoundary='pushSetting.user_boundary'
                    messageType='post'
                    :initailPushAgent='pushSetting.push_agent_on_publish_attributes'
                    @userBoundaryChanged='onUserBoundaryChangedFunc'
                    ref='pushSetting'/>
    </tab>
    <template v-if='enableTabs'>
      <tab name='发布名义' tabKey='release'>
        <release-setting :userBoundary="userBoundary"
                      :initialReleaseStatus="releaseSetting"
                      ref='releaseSettingRef'/>
      </tab>
      <tab name='消息标签' tabKey='tag'>
        <tags-namecard :initialTagIds='tagsNamecardSetting.tag_ids' ref='tagsNamecard'></tags-namecard>
      </tab>
      <tab name='评论设置' tabKey='comment'>
        <comment :initialCommentStatus='commentSetting.comment_status' ref='commentSetting' />
      </tab>
    </template>
    <template v-else>
      <div class="nav-item" slot="tab-control" @click='showMoreTabs'>
        <span>更多设置 &raquo;</span>
      </div>
    </template>
  </tabs>
</modal>`,
  created: function() {
    return this.userBoundary = this.pushSetting.user_boundary;
  },
  methods: {
    getData: function() {
      var _result, commentSetting, pushSetting, ref, ref1, releaseSetting, releaseSettingRefs, tagsNamecardSetting;
      pushSetting = this.$refs.pushSetting.getData();
      tagsNamecardSetting = ((ref = this.$refs.tagsNamecard) != null ? ref.getData() : void 0) || this.tagsNamecardSetting;
      commentSetting = ((ref1 = this.$refs.commentSetting) != null ? ref1.getData() : void 0) || this.commentSetting;
      releaseSettingRefs = this.$refs.releaseSettingRef;
      releaseSetting = releaseSettingRefs ? releaseSettingRefs.getData() ? releaseSettingRefs.getData() : null : {};
      return _result = {
        pushSetting: pushSetting,
        tagsNamecardSetting: tagsNamecardSetting,
        commentSetting: commentSetting,
        releaseSetting: releaseSetting
      };
    },
    onUserBoundaryChangedFunc: function(ub) {
      return this.userBoundary = ub;
    }
  }
});

export var FormSettingsModal = Vue.extend({
  mixins: [MessageSettingsMixins],
  components: {
    'release-setting': ReleaseSetting,
    'response-settings': ResponseSetting,
    'after-submit-settings': AfterSubmitSetting,
    'comment': CommentSetting,
    'red-packet-setting': RedPacketSetting,
    'table-mapper-setting': TableMapperSetting
  },
  data: function() {
    return {
      closeSetting: {},
      userFillSetting: {},
      afterSubmitSetting: {},
      commentSetting: {},
      redpacketSetting: {},
      releaseSetting: {},
      tableMapperSetting: false,
      userBoundary: null
    };
  },
  template: `<modal title='发布确认'
       extendClass='message-modal'
       @ensureClicked='ensureClicked'
       @cancelClicked='_cacheSettings'>
  <tabs customClass='setting-tabs message-settings'
        navsClass='nav reverse'>
    <tab name='接收推送' tabKey='push'>
      <push-setting :initailUserBoundary='pushSetting.user_boundary'
                    messageType='form'
                    :initailPushAgent='pushSetting.push_agent_on_publish_attributes'
                    @userBoundaryChanged='onUserBoundaryChangedFunc'
                    ref='pushSetting'/>
    </tab>
    <template v-if='enableTabs'>
      <tab name='发布名义' tabKey='release'>
        <release-setting :userBoundary="userBoundary"
                      :initialReleaseStatus="releaseSetting"
                      ref='releaseSettingRef'/>
      </tab>
      <tab name='名义标签' tabKey='tag'>
        <tags-namecard :initialTagIds='tagsNamecardSetting.tag_ids' ref='tagsNamecard'></tags-namecard>
      </tab>
      <tab name='用户填写' tabKey='userFill'>
        <response-settings :initialCloseSettings="closeSetting"
                           :initialSettings='userFillSetting'
                           ref='responseSettings' />
      </tab>
      <tab name='填写完成' tabKey='complete'>
        <after-submit-settings :initialAfterSubmitSetting='afterSubmitSetting'
                               ref='afterSubmitSettings' />
      </tab>
      <tab name='评论设置' tabKey='comment'>
        <comment :initialCommentStatus='commentSetting.comment_status' ref='commentSetting' />
      </tab>
      <tab name='红包' tabKey='red_packet'>
        <red-packet-setting ref='red_packetSettings'
                            :initialSettings='redpacketSetting' />
      </tab>
      <tab name='数据映射' tabKey='tableMapper'>
        <table-mapper-setting ref='tableMapperSettingRef'
                              :initialSettings='tableMapperSetting' />
      </tab>
    </template>
    <template v-else>
      <div class="nav-item" slot="tab-control" @click='showMoreTabs'>
        <span>更多设置 &raquo;</span>
      </div>
    </template>
  </tabs>
</modal>`,
  created: function() {
    return this.userBoundary = this.pushSetting.user_boundary;
  },
  methods: {
    getData: function() {
      var _result, afterSubmitSetting, commentSetting, pushSetting, redpacketSetting, ref, ref1, ref2, ref3, ref4, ref5, releaseSetting, releaseSettingRefs, response_settings, tableMapperSetting, tagsNamecardSetting;
      pushSetting = this.$refs.pushSetting.getData();
      tagsNamecardSetting = ((ref = this.$refs.tagsNamecard) != null ? ref.getData() : void 0) || this.tagsNamecardSetting;
      response_settings = ((ref1 = this.$refs.responseSettings) != null ? ref1.getData() : void 0) || {
        closeSetting: this.closeSetting,
        responseSettings: this.userFillSetting
      };
      afterSubmitSetting = ((ref2 = this.$refs.afterSubmitSettings) != null ? ref2.getData() : void 0) || this.afterSubmitSetting;
      commentSetting = ((ref3 = this.$refs.commentSetting) != null ? ref3.getData() : void 0) || this.commentSetting;
      redpacketSetting = ((ref4 = this.$refs.red_packetSettings) != null ? ref4.getData() : void 0) || this.redpacketSetting;
      releaseSettingRefs = this.$refs.releaseSettingRef;
      releaseSetting = releaseSettingRefs ? releaseSettingRefs.getData() ? releaseSettingRefs.getData() : null : {};
      tableMapperSetting = ((ref5 = this.$refs.tableMapperSettingRef) != null ? ref5.getData() : void 0) || this.tableMapperSetting;
      return _result = {
        pushSetting: pushSetting,
        tagsNamecardSetting: tagsNamecardSetting,
        userFillSetting: response_settings.responseSettings,
        closeSetting: response_settings.closeSetting,
        afterSubmitSetting: afterSubmitSetting,
        commentSetting: commentSetting,
        redpacketSetting: redpacketSetting,
        releaseSetting: releaseSetting,
        tableMapperSetting: tableMapperSetting
      };
    },
    onUserBoundaryChangedFunc: function(ub) {
      return this.userBoundary = ub;
    },
    _separateParams: function() {
      this._setPushSetting();
      this._setTagsNamecardSetting();
      this._setResponseSetting();
      this._setAfterSubmitSetting();
      this._setCommentSetting();
      return this._setRedpacketSetting();
    },
    _setResponseSetting: function() {
      var ref;
      this.closeSetting = _.pick(this.message, 'responses_limit', 'closed_at');
      this.userFillSetting = _.pick(this.message, 'response_required', 'anonymous_allowed', 'step_renderable', 'enable_appendable', 'submit_once');
      return this.userFillSetting.responses_sharing = ((ref = this.message.settings) != null ? ref.responses_sharing : void 0) || false;
    },
    _setAfterSubmitSetting: function() {
      return this.afterSubmitSetting = _.pick(this.message, 'after_submit_action', 'after_submit_show_message', 'success_message', 'after_submit_redirect_url');
    },
    _setCommentSetting: function() {
      return this.commentSetting = _.pick(this.message, 'comment_status');
    },
    _setRedpacketSetting: function() {
      return this.redpacketSetting = this.message.red_packet_setting || {};
    }
  }
});

export var newMessageSettingsModal = function(message, props = {
    type: 'post'
  }) {
  var el, modal_comp;
  el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('modal_container');
  modal_comp = (function() {
    switch (props.type) {
      case 'form':
        return FormSettingsModal;
      default:
        return MessageSettingsModal;
    }
  })();
  return new modal_comp({
    el: el,
    propsData: {
      message: message
    }
  });
};
